// TEXT input for "ProductCategory"
const Input = {
    // General Information
    name: {
      category:'Clothing',
    },
  
    // Sort Filter
    sortOptions: [
        { name: 'Most Popular', href: 'https://www.google.com/', current: true },
        { name: 'Best Rating', href: 'https://www.google.com/', current: false },
        { name: 'Newest', href: 'https://www.google.com/', current: false },
        { name: 'Price: Low to High', href: 'https://www.google.com/', current: false },
        { name: 'Price: High to Low', href: 'https://www.google.com/', current: false },
    ],
  
    // Category Filter
    subCategories: [
        { name: 'Tops', href:'/men/clothing/tops'},
        { name: 'Bottoms', href: '/men/clothing/bottoms' },
        { name: 'Innerwear', href: '/men/clothing/innerwear' },
        { name: 'Outerwear', href: '/men/clothing/outerwear' },
        { name: 'Activewear', href: '/men/clothing/activewear' },
    ],
  
    // Specific Category Filters
    filters: [
      {
        id: 'category',
        name: 'Category',
        options: [
          { value: 'new-arrivals', label: 'New Arrivals', checked: false },
          { value: 'sale', label: 'Sale', checked: false },
          { value: 'travel', label: 'Travel', checked: false },
          { value: 'organization', label: 'Organization', checked: false },
          { value: 'accessories', label: 'Accessories', checked: false },
        ],
      },    
      {
        id: 'color',
        name: 'Color',
        options: [
          { value: 'white', label: 'White', checked: false },
          { value: 'beige', label: 'Beige', checked: false },
          { value: 'blue', label: 'Blue', checked: false },
          { value: 'brown', label: 'Brown', checked: false },
          { value: 'green', label: 'Green', checked: false },
          { value: 'purple', label: 'Purple', checked: false },
        ],
      },
      {
        id: 'size',
        name: 'Size',
        options: [
          { value: '2l', label: '2L', checked: false },
          { value: '6l', label: '6L', checked: false },
          { value: '12l', label: '12L', checked: false },
          { value: '18l', label: '18L', checked: false },
          { value: '20l', label: '20L', checked: false },
          { value: '40l', label: '40L', checked: false },
        ],
      },
    ],
  
    // Product Listing
    products: [
      {
        id: 1,
        name: 'Nike Sportswear Premium Essentials',
        category: "Men's T-Shirts",
        href: './tops/nike1',
        price: '$45',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p5.png',
        imageAlt: 'image 1',
      },
      {
        id: 2,
        name: 'Navi Jeans',
        category: "Pants",
        href: './bottoms/zara1',
        price: '$30',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p2.png',
        imageAlt: 'image 2',
      },
      {
        id: 3,
        name: 'Summer Loose Shirt',
        category: "Men's Shirts",
        href: './tops/nike3',
        price: '$45',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p3.png',
        imageAlt: 'image 3',
      },
      {
        id: 4,
        name: 'ACG Jacket',
        category: "Men's Jackets",
        href: './tops/nike4',
        price: '$55',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p8.png',
        imageAlt: 'image 4',
      },
      {
        id: 5,
        name: 'Men Polo',
        category: "Men's T-Shirts",
        href: './tops/nike2',
        price: '$55',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p8.png',
        imageAlt: 'image 5',
      },
      {
        id: 6,
        name: 'Men Pants',
        category: "Pants",
        href: './bottoms/zara2',
        price: '$30',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p5.png',
        imageAlt: 'image 6',
      },
      {
        id: 7,
        name: 'T Shirt',
        category: "Men's T-Shirts",
        href: './tops/nike5',
        price: '$55',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p1.png',
        imageAlt: 'image 7',
      },
      {
        id: 8,
        name: 'Collar Shirt',
        category: "Men's Shirts",
        href: './tops/nike6',
        price: '$55',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_1/c1_p4.png',
        imageAlt: 'image 7',
      },
      {
        id: 9,
        name: 'Logo T Shirt',
        category: "Men's T-Shirts",
        href: './tops/nike7',
        price: '$55',
        imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/preview/collection_2/c2_p7.png',
        imageAlt: 'image 7',
      },
    ]
  }
  
  export default Input;